module.exports = __webpack_public_path__ + "static/firechat-demo-ffc8d41b9308c0949381d9f64f4bd804.png";